/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 2Sac1UHK8925

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicLogo.module.css"; // plasmic-import: 2Sac1UHK8925/css

createPlasmicElementProxy;

export type PlasmicLogo__VariantMembers = {
  product: "myEvaluations" | "myCme" | "myGme";
  grayscale: "grayscale";
  interactable: "interactable";
};
export type PlasmicLogo__VariantsArgs = {
  product?: SingleChoiceArg<"myEvaluations" | "myCme" | "myGme">;
  grayscale?: SingleBooleanChoiceArg<"grayscale">;
  interactable?: SingleBooleanChoiceArg<"interactable">;
};
type VariantPropType = keyof PlasmicLogo__VariantsArgs;
export const PlasmicLogo__VariantProps = new Array<VariantPropType>(
  "product",
  "grayscale",
  "interactable"
);

export type PlasmicLogo__ArgsType = {
  onClick?: () => void;
  hoverText?: string;
};
type ArgPropType = keyof PlasmicLogo__ArgsType;
export const PlasmicLogo__ArgProps = new Array<ArgPropType>(
  "onClick",
  "hoverText"
);

export type PlasmicLogo__OverridesType = {
  root?: Flex__<typeof PlasmicImg__>;
};

export interface DefaultLogoProps {
  onClick?: () => void;
  hoverText?: string;
  product?: SingleChoiceArg<"myEvaluations" | "myCme" | "myGme">;
  grayscale?: SingleBooleanChoiceArg<"grayscale">;
  interactable?: SingleBooleanChoiceArg<"interactable">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicLogo__RenderFunc(props: {
  variants: PlasmicLogo__VariantsArgs;
  args: PlasmicLogo__ArgsType;
  overrides: PlasmicLogo__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "product",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.product
      },
      {
        path: "grayscale",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.grayscale
      },
      {
        path: "interactable",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.interactable
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <PlasmicImg__
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      alt={
        hasVariant($state, "product", "myGme")
          ? "MyGME FISCAL logo"
          : hasVariant($state, "product", "myCme")
            ? "MyCME Logo"
            : "MyEvaluations Logo"
      }
      aria-label={
        hasVariant($state, "product", "myGme")
          ? "MyGME FISCAL logo"
          : hasVariant($state, "product", "myCme")
            ? "MyCME Logo"
            : "MyEvaluations Logo"
      }
      className={classNames(
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootgrayscale]: hasVariant($state, "grayscale", "grayscale"),
          [sty.rootgrayscale_product_myCme]:
            hasVariant($state, "product", "myCme") &&
            hasVariant($state, "grayscale", "grayscale"),
          [sty.rootgrayscale_product_myGme]:
            hasVariant($state, "grayscale", "grayscale") &&
            hasVariant($state, "product", "myGme"),
          [sty.rootinteractable]: hasVariant(
            $state,
            "interactable",
            "interactable"
          ),
          [sty.rootproduct_myCme]: hasVariant($state, "product", "myCme"),
          [sty.rootproduct_myEvaluations]: hasVariant(
            $state,
            "product",
            "myEvaluations"
          ),
          [sty.rootproduct_myEvaluations_grayscale]:
            hasVariant($state, "product", "myEvaluations") &&
            hasVariant($state, "grayscale", "grayscale"),
          [sty.rootproduct_myGme]: hasVariant($state, "product", "myGme")
        }
      )}
      displayHeight={
        hasVariant($state, "product", "myGme")
          ? "auto"
          : hasVariant($state, "product", "myCme")
            ? "auto"
            : "19.887px"
      }
      displayMaxHeight={"none"}
      displayMaxWidth={"100%"}
      displayMinHeight={"0"}
      displayMinWidth={"0"}
      displayWidth={
        hasVariant($state, "product", "myGme")
          ? "97.5px"
          : hasVariant($state, "product", "myCme")
            ? "54px"
            : "113.777px"
      }
      loader={"plasmic"}
      loading={"lazy"}
      onClick={async event => {
        const $steps = {};

        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
      src={
        hasVariant($state, "product", "myGme")
          ? {
              src: "https://site-assets.plasmic.app/9fd573b79cd2a308d894f39aa424fd70.svg",
              fullWidth: 220,
              fullHeight: 46,
              aspectRatio: 4.782609
            }
          : hasVariant($state, "product", "myCme")
            ? {
                src: "https://site-assets.plasmic.app/78d6d60c4e6cb4ef6edce275a40282b3.svg",
                fullWidth: 300,
                fullHeight: 116,
                aspectRatio: 2.595745
              }
            : {
                src: "https://site-assets.plasmic.app/e0d717efc79e1714572b0ff755fc9dba.svg",
                fullWidth: 113.777,
                fullHeight: 19.887,
                aspectRatio: 5.7
              }
      }
      style={(() => {
        try {
          return {
            userSelect: "none"
          };
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      title={(() => {
        try {
          return $props.hoverText;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    />
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof PlasmicImg__;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLogo__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLogo__VariantsArgs;
    args?: PlasmicLogo__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicLogo__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicLogo__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLogo__ArgProps,
          internalVariantPropNames: PlasmicLogo__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLogo__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLogo";
  } else {
    func.displayName = `PlasmicLogo.${nodeName}`;
  }
  return func;
}

export const PlasmicLogo = Object.assign(
  // Top-level PlasmicLogo renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicLogo
    internalVariantProps: PlasmicLogo__VariantProps,
    internalArgProps: PlasmicLogo__ArgProps
  }
);

export default PlasmicLogo;
/* prettier-ignore-end */
